import React, { useState } from 'react';
import BaseGridToolbar from '../../components/shared/toolbar/BaseGridToolbar';
import AuctionFormModal from './AuctionFormModal';

export default function AuctionListToolbar({
  columns,
  data,
  showQuickFilter,
  quickFilterProps
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const actionButton = (
    <button
      type="button"
      onClick={() => setIsModalOpen(true)}
      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="-ml-1 mr-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
      </svg>
      Add Auction
    </button>
  );

  return (
    <>
      <BaseGridToolbar
        title="Auctions"
        columns={columns}
        data={data}
        actionButton={actionButton}
        showQuickFilter={showQuickFilter}
        quickFilterProps={quickFilterProps}
      />
      <AuctionFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
